import React from 'react'

function CommonCourseComponents({ degree }) {
  if (degree) {
    switch (degree) {
      case "Bachelor’s Degree":
      case "4":
        return <div className="degree-type degree-bachelor">
          <span title="Bachelor’s Degree" className="name"><i className="fas fa-graduation-cap" />Bachelor’s Degree</span>
        </div>
      case "Higher Certificate":
      case "3":
        return <div className="degree-type degree-higher">
          <span title="Higher Certificate" className="name"><i className="fas fa-file-certificate" />Higher certificate</span>
        </div>
      case "Diploma":
      case "2":
        return <div className="degree-type degree-diploma">
          <span title="Diploma" className="name"><i className="fas fa-certificate" />diploma</span>
        </div>
      case "National Certificate":
      case "1":
      case "Certificate":
        return <div className="degree-type degree-national">
          <span title="National Certificate" className="name"><i className="fas fa-award" />National certificate</span>
        </div>
      case "Master Certificate":
        return <div className="degree-type degree-master">
          <span title="Master Certificate" className="name"><i className="fas fa-university" />Master certificate</span>
        </div>
      case "Occupational Certificate":
        return <div className="degree-type degree-occupational">
          <span title="Occupational Certificate" className="name"><i className="fas fa-user-graduate" />occupational certificate</span>
        </div>
      case "Honours Degree":
        case "5" :
        return <div className="degree-type degree-honours">
          <span title="honours Degree" className="name"><i className="fas fa-medal" />honours Degree</span>
        </div>
      case "Learning Path":
      case "7":
        return <div className="degree-type degree-learning">
          <span title="Learning path" className="name"><i className="fas fa-route" />learning Path</span>
        </div>
      case "Master’s Degree":
        return <div className="degree-type degree-master">
          <span title="Master’s Degree" className="name"><i className="fas fa-university" />Master’s Degree</span>
        </div>
      default:
        return <div className="degree-type degree-learning">
        <span title="name" className="name">N/A</span>
      </div>
    }
  }
  else {
    return null
  }
}
export default CommonCourseComponents


export function ProgramIcons({ degree }) {
  if (degree) {
    switch (degree) {
      case "Bachelor’s Degree":
      case "4":
        return <i className="fas fa-graduation-cap" title='Bachelor’s Degree'/>
      case "Higher Certificate":
      case "3":
        return <i className="fas fa-file-certificate" title='Higher Certificate'/>
      case "Diploma":
      case "2":
        return <i className="fas fa-certificate" title='Diploma'/>
      case "National Certificate":
      case "1":
      case "Certificate":
        return <i className="fas fa-award" title='National Certificate'/>
      case "Master Certificate":
        return <i className="fas fa-university" title='Master Certificate'/>
      case "Occupational Certificate":
        return <i className="fas fa-user-graduate" title='Occupational Certificate'/>
      case "Honours Degree":
      case "5":
        return <i className="fas fa-medal" title='Honours Degree'/>
      case "Learning Path":
      case "7":
        return <i className="fas fa-route" title='Learning Path'/>
      case "Master’s Degree":
        return <i className="fas fa-university" title='Master’s Degree'/>
      default:
        return "N/A"
    }
  }
  else {
    return null
  }
}